module.exports = __webpack_public_path__ + "media/images/service/n_5-655ca7d844b40979bfa7f0a1cc7d9f8d.jpg";